module.exports = __webpack_public_path__ + "media/hint-onboarding.d1d07ea1.webm";